import React from "react";
import { useDispatch } from "react-redux";
import "./CartItem-Style.css";
import { Link } from "react-router-dom";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const CartItem = ({ item }) => {
  const dispatch = useDispatch();
  console.log(item);
  return (
    <div className="cartItem">
      <div className="details">
        <div className="image">
          <img src={SERVER_URL+`/uploads/products/${item.pImages[0]}`} alt={item.title} />
        </div>
        <div className="desc">
          <Link to={`/product/${item._id}`}>
            <div className="title">{item.pName}</div>
          </Link>
          <div className="size">{item.pDescription}</div>
          <div className="price" style={{ display: "flex", alignItems: "center" }}>
            <span>
              ₹{Math.floor(item.pPrice * (100 - item.pOffer) / 100)*item.quantity}
            </span>
            <span style={{ fontWeight: 400, marginLeft: "8px", fontSize: "16px", opacity: "0.8", lineHeight: 1.2, paddingTop: "2px" }}>
              <s>₹{item.pPrice*item.quantity}</s>
            </span>
            <span style={{
              fontWeight: 400, marginLeft: "8px", fontSize: "16px",
              letterSpacing: ".5px",
              color: "#ff905a" , paddingTop: "2px"
            }}>
              {item.pOffer}% OFF
            </span>
          </div>
        </div>
      </div>
      <div className="qty-row">
        <div className="qty">
          <button
            className="dec"
            onClick={() => dispatch({ type: "DEC", payload: item._id })}
          >
            -
          </button>
          <div className="qty-value">{item.quantity}</div>
          <button
            className="dec"
            onClick={() => dispatch({ type: "INC", payload: item._id })}
          >
            +
          </button>
        </div>
        <div className="remove-btn">
          <button
            onClick={() => dispatch({ type: "REMOVE", payload: item._id })}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
